export default "__VITE_ASSET__12b71905__"